import React, { createContext, useEffect } from 'react';
import { initPrebid } from '../utils/prebidSetup';

export interface PrebidContextType {
  pbjs: any;
  refresh: () => void;
}

export const PrebidContext = createContext<PrebidContextType | null>(null);

interface PrebidProviderProps {
  children: React.ReactNode;
  config: {
    bidders: Array<{
      bidder: string;
      params: Record<string, any>;
    }>;
    timeout: number;
  };
}

export const PrebidProvider: React.FC<PrebidProviderProps> = ({ children, config }) => {
  useEffect(() => {
    initPrebid(config);
  }, [config]);

  const refresh = () => {
    window.pbjs.requestBids({
      bidsBackHandler: () => {
        window.googletag.pubads().refresh();
      }
    });
  };

  return (
    <PrebidContext.Provider value={{ pbjs: window.pbjs, refresh }}>
      {children}
    </PrebidContext.Provider>
  );
}; 